export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-foreground-900 via-foreground-800 to-secondary-900 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 text-background-50">
              <h2 className="font-heading font-bold text-2xl md:text-3xl mb-3">51每日爆料 APP · 吃瓜更快一步</h2>
              <p className="text-foreground-300 text-sm md:text-base leading-relaxed mb-5">
                下载51每日爆料官方APP，随时随地掌握最新吃瓜资讯。支持iOS和Android双平台，推送速度比网页版快3秒，让你永远领先吃瓜第一线。内置个性化推荐算法，越刷越懂你。
              </p>
              <div className="flex flex-wrap items-center gap-4 mb-6">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-lg bg-primary-500/30 flex items-center justify-center">
                    <i className="ri-smartphone-line text-primary-300"></i>
                  </div>
                  <span className="text-xs md:text-sm text-foreground-300">iOS / Android 双端支持</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-lg bg-accent-500/30 flex items-center justify-center">
                    <i className="ri-notification-3-line text-accent-300"></i>
                  </div>
                  <span className="text-xs md:text-sm text-foreground-300">实时推送快人3秒</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-lg bg-primary-500/30 flex items-center justify-center">
                    <i className="ri-shield-check-line text-primary-300"></i>
                  </div>
                  <span className="text-xs md:text-sm text-foreground-300">纯净无广告体验</span>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href="#app"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-fill"></i>
                  iOS 版下载
                </a>
                <a
                  href="#app"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-fill"></i>
                  Android 版下载
                </a>
              </div>
            </div>
            <div className="w-full max-w-[280px] aspect-[9/16] rounded-2xl overflow-hidden bg-foreground-700 relative">
              <div className="absolute inset-0 flex flex-col">
                <div className="h-10 bg-primary-600 flex items-center px-3">
                  <span className="text-[10px] text-background-50 font-semibold">每日爆料</span>
                </div>
                <div className="flex-1 p-3 space-y-2">
                  <div className="h-3 bg-foreground-500 rounded w-3/4"></div>
                  <div className="h-2 bg-foreground-500 rounded w-full"></div>
                  <div className="h-2 bg-foreground-500 rounded w-5/6"></div>
                  <div className="h-16 bg-primary-500/20 rounded mt-2"></div>
                  <div className="h-2 bg-foreground-500 rounded w-full"></div>
                  <div className="h-2 bg-foreground-500 rounded w-4/5"></div>
                  <div className="h-16 bg-accent-500/20 rounded mt-2"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}